module.exports = __webpack_public_path__ + "img/img_10.26dfa684.jpg";